import type { ValueOf } from 'type-fest';

export const themes = {
  default: 'default',
  fullToWide: 'full-to-wide',
  medium: 'medium',
  narrow: 'narrow',
  veryNarrow: 'very-narrow',
  wide: 'wide',
} as const;

export interface ContentContainer {
  className?: string;
  id?: string;
  raw?: boolean;
  theme?: ValueOf<typeof themes>;
}
